import { CancelButton } from 'shared/mui/Buttons';
import { BaseDialog, BaseDialogProps } from 'shared/mui/Dialogs';

type Props = BaseDialogProps & {
  message: string | React.ReactNode;
};

export const ReportExportErrorDialog: React.FC<Props> = ({
  onClose,
  open,
  title,
  message,
  ...restProps
}) => {
  return (
    <BaseDialog
      message={message}
      onClose={onClose}
      open={open}
      rightActionsSlot={[
        <CancelButton key="cancel-button" label="Закрыть" onClick={onClose} variant="outlined" />,
      ]}
      title={title}
      width="640px"
      {...restProps}
    />
  );
};
